<template>
<div @click="btnBackTop" class="backTop">
    <img src="../../../static/img/assets/btn-icon-top.png" alt="">
</div>
</template>
<script>
export default {
    data () {
        return {
            clientHeight: null,
            timer: null,
            isTop: null,
            scrollTop: null,
            speed: null
        }
    },
    methods: {
        btnBackTop () {
            // let top = document.body.scrollTop || document.documentElement.scrollTop
            // scrollBy(0, -top)
            this.clientHeight = document.documentElement.clientHeight
            this.timer = null
            this.isTop = true
            this.stop()
        },
        stop () {
            this.timer = setInterval(() => {
                this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                this.speed = Math.floor(-this.scrollTop / 3)
                document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + this.speed
                this.isTop = true
                if (this.scrollTop === 0) {
                    clearInterval(this.timer)
                }
                window.onscroll = () => {
                    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                    if (!this.isTop) {
                        clearInterval(this.timer)
                    }
                    this.isTop = false
                }
            }, 50)
        }
    }
}
</script>
<style>
.backTop {
  position: absolute;
  bottom: 1.7%;
  right: 3.5%;
  transition: 0.7s;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// BackTop.vue?2e55c9c0